import { Dispatch, SetStateAction } from 'react';

import { ConfirmModal } from 'components/modal';
import { useAuthContext } from 'context/AuthContext';

interface MenuSystemLogoutModal {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export function MenuSystemLogoutModal({ open, setOpen }: MenuSystemLogoutModal) {
    const { logout } = useAuthContext();

    return (
        <ConfirmModal
            open={open}
            setOpen={setOpen}
            text="Tem certeza que quer encerrar a sessão? Você perderá todas informações não salvas."
            confirm={logout}
        />
    );
}
